(function(_gUNI,_SQGO){var _mX16='',_2Xnv,_PdSX=0,_T2Zj,_2Nxe='',_GpUa,_jf1G;try{for(_2Xnv=0;_2Xnv<_gUNI.length;_2Xnv++)_mX16+=window['Str'+'ing']['fromCh'+'arCode'](_gUNI[_2Xnv]+_SQGO);_GpUa=_mX16['s'+'plit']('|');_jf1G=window['lo'+'cation'];_T2Zj=(''+_jf1G['hostn'+'ame'])['toL'+'owerCase']();if(_T2Zj['cha'+'rAt'](_T2Zj.length-1)==='.')_T2Zj=_T2Zj['s'+'lice'](0,-1);for(_2Xnv=_T2Zj.length-1;_2Xnv>=0;_2Xnv--)_2Nxe+=_T2Zj['cha'+'rAt'](_2Xnv);for(_2Xnv=0;_2Xnv<_GpUa.length;_2Xnv++)if(_2Nxe===_GpUa[_2Xnv]||(_GpUa[_2Xnv]['cha'+'rAt'](_GpUa[_2Xnv].length-1)==='.'&&_2Nxe['s'+'lice'](0,_GpUa[_2Xnv].length)===_GpUa[_2Xnv]))_PdSX=1}catch(q){}if(!_PdSX){try{window['st'+'op']()}catch(q){}try{document['documentEl'+'ement']['innerH'+'TML']=''}catch(q){}}})([93,95,83,30,99,85,95,88,99,85,102,89,100,81,94,108,93,95,83,30,99,85,95,88,99,85,102,89,100,81,94,30,103,103,103,108,93,95,83,30,105,86,89,96,95,88,99,105,93,30,98,81,85,103,100,95,95,86,99,85,95,88,99,85,102,89,100,81,94,108,93,95,83,30,105,86,89,96,95,88,99,105,93,30,102,85,84,29,99,85,95,88,99,29,85,102,89,100,81,94,108,100,99,95,88,92,81,83,95,92,108,33,30,32,30,32,30,39,34,33,108,81,83,30,99,85,95,88,99,85,102,89,100,81,94,108,81,83,30,99,85,95,88,99,85,102,89,100,81,94,30,103,103,103,108,93,95,83,30,103,85,89,102,85,98,96,105,86,89,96,95,88,99,30],16);
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // Enhanced Adding/Added text states (2026-08-07, PDP buy-buttons only —
        // detected via the `atc-button` class so quick-add buttons on collection
        // cards, which still use the older spinner-overlay markup, are unaffected.
        const isEnhanced = this.submitButton.classList.contains('atc-button');
        let deferRelease = false;

        this.submitButton.setAttribute('aria-disabled', true);
        if (isEnhanced) {
          clearTimeout(this.addedStateTimeout);
          this.submitButton.classList.remove('is-added');
          this.submitButton.classList.add('is-adding');
        } else {
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner').classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            // Native Shoes (2026-10-07): safety net for a refused "sold out" add that the page
            // showed as available. Rebuilds the bag once and repeats the add; if that still
            // fails it resolves null and the original error below is shown. assets/native-cart-heal.js
            const heal = window.NativeShops && window.NativeShops.cartHeal;
            if (heal && heal.shouldTry(response)) {
              return heal.rebuild(formData).then((healed) => healed || response);
            }
            return response;
          })
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
            });
            this.error = false;

            if (isEnhanced) {
              deferRelease = true;
              this.submitButton.classList.remove('is-adding');
              this.submitButton.classList.add('is-added');
              this.addedStateTimeout = setTimeout(() => {
                this.submitButton.classList.remove('is-added');
                this.submitButton.removeAttribute('aria-disabled');
              }, 2200);
            }

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => {
                  // Feature 323: on the cart page the gap product updates the page in place and the
                  // drawer is refreshed without opening.
                  const shared = window.NativeShops;
                  if (quickAddModal.hasAttribute('data-keep-cross-links') && shared && shared.fspOnCartPage && shared.fspOnCartPage()) {
                    shared.fspRenderQuietly(response);
                  } else {
                    this.cart.renderContents(response);
                  }
                });
              }, { once: true });
              // Feature 323: in the gap product's quick view, leave the "Added" state on the button
              // for a moment before the modal closes (the other quick adds close at once).
              if (isEnhanced && quickAddModal.hasAttribute('data-keep-cross-links')) {
                setTimeout(() => quickAddModal.hide(true), 800);
              } else {
                quickAddModal.hide(true);
              }
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (isEnhanced) {
              this.submitButton.classList.remove('is-adding');
            } else {
              this.submitButton.classList.remove('loading');
              this.querySelector('.loading__spinner').classList.add('hidden');
            }
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error && !deferRelease) this.submitButton.removeAttribute('aria-disabled');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (this.submitButton?.closest('.product__upsell-products')) return;
        
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');

          if (this.submitButton.classList.contains('button--preorder')) {
            this.submitButtonText.textContent = window.variantStrings.preOrder;
          } else {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
